var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddPlus(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.625 8.8125C17.625 8.96168 17.5657 9.10476 17.4602 9.21025C17.3548 9.31574 17.2117 9.375 17.0625 9.375H9.375V17.0625C9.375 17.2117 9.31574 17.3548 9.21025 17.4602C9.10476 17.5657 8.96168 17.625 8.8125 17.625C8.66332 17.625 8.52024 17.5657 8.41475 17.4602C8.30926 17.3548 8.25 17.2117 8.25 17.0625V9.375H0.5625C0.413316 9.375 0.270242 9.31574 0.164752 9.21025C0.0592632 9.10476 0 8.96168 0 8.8125C0 8.66332 0.0592632 8.52024 0.164752 8.41475C0.270242 8.30926 0.413316 8.25 0.5625 8.25H8.25V0.5625C8.25 0.413316 8.30926 0.270242 8.41475 0.164752C8.52024 0.0592632 8.66332 0 8.8125 0C8.96168 0 9.10476 0.0592632 9.21025 0.164752C9.31574 0.270242 9.375 0.413316 9.375 0.5625V8.25H17.0625C17.2117 8.25 17.3548 8.30926 17.4602 8.41475C17.5657 8.52024 17.625 8.66332 17.625 8.8125Z",
    fill: "#FA873C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddPlus);
export default __webpack_public_path__ + "static/media/AddPlus.e3b476e62f6260ff12843ae6ec3eb757.svg";
export { ForwardRef as ReactComponent };